<template>
    <section
        name="header"
        class="px-sm py-md fixed top-0 z-1 flex w-full items-end justify-between rounded-b-md bg-primary shadow-md transition-all duration-300 ease-in-out"
        :class="isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'"
    >
        <RouterLink :to="'/'">
            <i class="i-icon block h-7 w-10" />
        </RouterLink>
        <button
            v-if="!isLMSView"
            class="gap-md flex cursor-pointer items-center py-0 pr-4"
            @click="toggleMobileMenu"
        >
            <i class="i-menu h-6 w-6 cursor-pointer" />
        </button>
    </section>

    <transition name="fade">
        <MobileMenu v-if="mobileMenu && !isLMSView" @close="toggleMobileMenu" />
    </transition>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import MobileMenu from '@/components/mobile/mobile-menu.vue';
import { useIsLMSView } from '@/composables/isLMSView';

const mobileMenu = ref(false);

function toggleMobileMenu() {
    mobileMenu.value = !mobileMenu.value;
}
const isLMSView = useIsLMSView();
const isVisible = ref(true);
const props = defineProps<{
    scrollTarget: HTMLElement;
}>();

let lastScrollY = props.scrollTarget.scrollTop;

function handleScroll() {
    const currentScrollY = props.scrollTarget.scrollTop;

    if (currentScrollY > lastScrollY && currentScrollY > 40) {
        // scrolling down
        isVisible.value = false;
    } else {
        // scrolling up
        isVisible.value = true;
    }

    lastScrollY = currentScrollY;
}

onMounted(() => {
    props.scrollTarget.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
    props.scrollTarget.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>
@reference '@/assets/styles/default.css';

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}
</style>
